import {Injectable} from "@angular/core";
import {datadogRum} from '@datadog/browser-rum';
import {environment} from "src/environments/environment";

export enum RUMContextKey {
    PLATFORM = 'Platform',
}

export abstract class RealUserMonitoringService {
    abstract init(): void;
    abstract setUser(user: any): void;
    abstract clearUser(): void;
    /**
     * Add extra context to the RUM events.
     */
    abstract setContext(key: RUMContextKey, value: any): void;
}

@Injectable()
export class DatadogRealUserMonitoringService implements RealUserMonitoringService {
    init(){
        if (environment.isDevelopment) {
            return;
        }
        datadogRum.init({
            applicationId: '48e60f27-1133-440f-aae2-1610fc97459c',
            clientToken: 'pub2e33ab529d99f4843671e6c580f5e9a4',
            site: 'datadoghq.eu',
            service:'euro.shop.web',
             //Connect RUM and Traces
            allowedTracingUrls:  [  
              { 
                match: (url: string) => url.startsWith("https://sapi-pre.europastry.com/euro.sapi"), 
                propagatorTypes: ["datadog"]
              },
              { 
                match: (url: string) => url.startsWith("https://sapi.europastry.com/euro.sapi"), 
                propagatorTypes: ["datadog"]
              },
            ],
            traceSampleRate: 100,
            //Heatmaps
            enableExperimentalFeatures: ['clickmap'],
            env: environment.DATADOG_ENVIRONMENT_CODE,
            // Specify a version number to identify the deployed version of your application in Datadog
            version: environment.PROJECT_VERSION,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel:'allow',
            startSessionReplayRecordingManually: true,
            });
            datadogRum.startSessionReplayRecording();
    }

    setUser(user: any){
        datadogRum.setUser(user);
    }
    clearUser(){
      datadogRum.clearUser();

    }

    setContext(key: RUMContextKey, value: any){
      datadogRum.setGlobalContextProperty(key, value);
    }
    
}
